var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCp3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.918,
    height: 45.004,
    viewBox: "0 0 46.918 45.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1675",
    "data-name": "Group 1675",
    transform: "translate(-362.413 -110.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M376.5,186.35l1.826-.118v-19.49h3.906v19.464h3.991V166.749h3.813v19.467h4.038V166.753h3.79v19.455h4.04V166.76h3.854v19.445h4V166.75h3.852v19.423l1.939.211v3.634H376.5Z",
    transform: "translate(-10.16 -40.869)",
    fill: "#da3981"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M.019,13.594A25.743,25.743,0,0,1,.05,10.937a1.342,1.342,0,0,1,.645-.9q10.092-5,20.225-9.912a1.825,1.825,0,0,1,1.4.033Q32.326,5.011,42.282,9.969a2.044,2.044,0,0,1,.842,1.319,12.313,12.313,0,0,1,.036,2.306Z",
    transform: "translate(364.259 110.073)",
    fill: "#da3981"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M409.331,258.323v3.668H362.413v-3.668Z",
    transform: "translate(0 -106.915)",
    fill: "#da3981"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp3);
export default __webpack_public_path__ + "static/media/cp3.339980395d1d7da7328729b7e38af6e6.svg";
export { ForwardRef as ReactComponent };